export const getPositionOverviewMonolithRoute = (constructionProjectId: string, positionId: string) => {
    return `order-management/projects/${constructionProjectId}/generic-positions/${positionId}`;
};

export const getPositionOrderDetailsMonolithRoute = (
    constructionProjectId: string,
    positionId: string,
    orderId: string
) => {
    return `order-management/projects/${constructionProjectId}/generic-positions/${positionId}/generic-order/${orderId}`;
};
